// @flow
import * as React from 'react';
import { DrugOutput } from '@coverright/data-access/types/medicare';
import {
  Box,
  ButtonBase, IconButton, Stack,
  Typography
} from '@mui/material';
import { useEffect, useRef, useState } from 'react';
import { X } from '@phosphor-icons/react';
import _ from 'lodash';
import { Tooltip } from '@coverright/ui/inputs';
import { useWindowSize } from '@coverright/utils';

type Props = {
  drug: DrugOutput,
  onEditClick: () => void,
  onDeleteClick: () => void,
};
export const DrugItem = ({drug, onEditClick, onDeleteClick}: Props) => {
  const ref = useRef<HTMLDivElement | null>(null);
  const [disableRipple, setDisableRipple] = useState(false)
  const [maxWidth, setMaxWidth] = useState(100);
  const size = useWindowSize()

  useEffect(() => {
    ref.current?.clientWidth && setMaxWidth(ref.current?.clientWidth - 70);
  }, [size]);

  const drugName = drug.packName ? drug.packName + (drug.notSupported ? ' (not supported)' : '') : '';

  return (
    <ButtonBase component={Stack} gap={1}
                disableRipple={disableRipple}
                onClick={onEditClick}
                ref={ref}
                sx={{p: '12px 16px', width: 1, alignItems: 'stretch', '&:hover': {bgcolor: 'secondary.50'}}}>
      <Stack direction={'row'} alignItems={'center'} justifyContent={'space-between'}>
        <Tooltip title={drugName}>
          <Box overflow={'hidden'} width={maxWidth} maxWidth={maxWidth} position={'relative'}>
            <Typography variant={'body2'} fontWeight={500} noWrap textOverflow={'initial'}>{drugName}</Typography>
            <Box sx={{position: 'absolute', top: 0, right: 0, bottom: 0, zIndex: 1, width: 35, background: 'linear-gradient(90deg, rgba(255,255,255,0) 0%, rgba(255,255,255,1) 100%)'}} />
          </Box>
        </Tooltip>

        <IconButton size={'small'} onClick={r => {
          r.stopPropagation();
          onDeleteClick()
        }}
                    onMouseEnter={() => setDisableRipple(true)}
                    onMouseLeave={() => setDisableRipple(false)}>
          <X size={16} color={'#DE3124'} />
        </IconButton>
      </Stack>

      <Stack gap={2} direction={'row'} justifyContent={'space-between'}>
        <Stack>
          <Typography variant={'caption'} color={'text.secondary'}>
            rxcui: {drug.packRxcui || drug.rxcui}
          </Typography>
          <Typography variant={'caption'} color={'text.secondary'}>
            {drug.isGeneric ? 'Generic' : 'Branded'}
          </Typography>
        </Stack>

        <Stack flex={1}>
          <Typography variant={'caption'} color={'text.secondary'} align={'right'}>
            Quantity: <Typography variant={'caption'} color={'text.secondary'} component={'span'} fontWeight={500}>
              {drug.quantity + ' ' + _.lowerCase(drug.frequency)}
            </Typography>
          </Typography>
          <Typography variant={'caption'} color={'text.secondary'} align={'right'}>
            Purchase frequency: <Typography variant={'caption'} color={'text.secondary'} component={'span'} fontWeight={500}>
              {_.upperFirst(drug.purchaseFrequency.toLowerCase())}
            </Typography>
          </Typography>
        </Stack>
      </Stack>

    </ButtonBase>
  );
};
